export default __webpack_public_path__ + "static/media/hazardous.72315c0b.png";